__turbopack_context__.v({
  "filter": "magazine-issue-filter-controls-module-scss-module__hHGDoG__filter",
  "filter__item": "magazine-issue-filter-controls-module-scss-module__hHGDoG__filter__item",
  "filter__item-list": "magazine-issue-filter-controls-module-scss-module__hHGDoG__filter__item-list",
});
